/** Есть активные ошибки? */
export var hasErrors = function hasErrors(errors) {
  return Object.values(errors).some(Boolean);
};